import React from 'react'
import { Row, Col } from 'react-bootstrap';
import { toMonetaryFormat } from '../../../common/Utilities';

export default function VarianceRevenueBreakdown({
  varianceBreakdown
}) {
  
  const renderBreakdowns = () => {

    return (
      <>
        <Row>
          <Col className="align-center breakdown-total-revenue">
            { toMonetaryFormat(+varianceBreakdown.varianceRevenue) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-fully-loaded-cost">
            { toMonetaryFormat(+varianceBreakdown.varianceFullyLoadedCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-unloaded-cost">
            { toMonetaryFormat(+varianceBreakdown.varianceUnloadedCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-external-cost">
            { toMonetaryFormat(+varianceBreakdown.varianceExternalCost) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-cost">
            { toMonetaryFormat(+varianceBreakdown.varianceTotalCost) } 
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-profit-before-tax">
            { toMonetaryFormat(+varianceBreakdown.varianceProfitBeforeTax) }
          </Col>
        </Row>
        <Row>
          <Col className="align-center breakdown-total-profit-after-tax">
            { toMonetaryFormat(+varianceBreakdown.varianceProfitNetofTax) }
          </Col>
        </Row>
      </>
    )
  }

  return (
    <Row>
      <Col>
        {renderBreakdowns()}
      </Col>
    </Row>
  )
}
